import React, { PropsWithChildren, useEffect } from 'react';

import { PostHogProvider } from 'posthog-js/react';

import { useKeycloak } from '@/auth/KeycloakAuthState.ts';
import { initSentry } from '@/observation_of_users/Sentry.tsx';

export const TrackingWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const impersonating = useKeycloak(state => state.impersonating);
  const enableTracking = !impersonating;
  useEffect(() => {
    initSentry();
  }, []);
  return (
    <PostHogProvider
      apiKey={'phc_GPFpM2rVdF5tPT0OfqjbD1pGHalzyGZbMaBZwQ2VYj3'}
      options={{
        api_host: 'https://eu.i.posthog.com',
        autocapture: enableTracking,
        enable_heatmaps: enableTracking,
        disable_session_recording: !enableTracking,
        capture_pageview: false,
      }}
    >
      {children}
    </PostHogProvider>
  );
};
